<template>
    <div class="page">
        <my-header :breadcrumb="breadcrumb"></my-header>
        <div class="content">
            <div class="content-wrap">
                <!--搜索-->
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                    <el-form-item>
                        <el-button type="primary" @click="clickAdd">添加分类</el-button>
                    </el-form-item>
                </el-form>
                <!-- 工具栏（列表名称、列表显示项设置） -->
                <el-dialog :title="formTitle" :visible.sync="dialogFormVisible">
                    <el-form :model="form">
                        <el-form-item label="分类名称" :label-width="formLabelWidth">
                            <el-input v-model="form.cate_name" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="上级分类" :label-width="formLabelWidth">
                            <el-cascader
                                    :options="options"
                                    v-model="selectedOptions"
                                    @change="handleChange">
                            </el-cascader>
                        </el-form-item>
                        <el-form-item label="分类图片" :label-width="formLabelWidth">
                            <el-upload
                                    class="avatar-uploader"
                                    :action="this.apiUrl+'/v1/upload/upload'" :headers="headers" :with-credentials="true"
                                    :show-file-list="false"
                                    :on-success="handleAvatarSuccess"
                                    :before-upload="beforeAvatarUpload">
                                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </el-form-item>

                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="confirmAdd">确 定</el-button>
                    </div>
                </el-dialog>
        <el-table
                :data="tableData"
                style="width: 100%;margin-bottom: 20px;"
                row-key="value">
            <el-table-column
                    prop="value"
                    label="id"
                    sortable
                    >
            </el-table-column>
            <el-table-column
                    prop="label"
                    label="分类名称"
                    sortable
                    >
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button
                            size="mini"
                            @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                    <el-button
                            size="mini"
                            type="danger"
                            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
            </div>
        </div>
    </div>
</template>

<script>
    import MyHeader from "../header";
    import Cookies from 'js-cookie'
    export default {
        name: "list",
        components:{
            MyHeader
        },
        data(){
            return {
                breadcrumb: [
                    {
                        name: '商品'
                    },
                    {
                        name: '分类列表'
                    }
                ],
                tableData:[],
                formInline:{},
                dialogFormVisible:false,
                form:{},
                formLabelWidth:'120px',
                formTitle:'添加分类',
                options:[],
                selectedOptions:[],
                imageUrl:'',
                headers:{
                    Authorization:'Bearer '+Cookies.get('access_token')
                }
            }
        },
        created(){

            this.$http.get('/v1/category/list',{params:{siteId:Cookies.get('siteId')}}).then(({data})=>{
              this.tableData = this.options = data;
            })
        },
        methods:{
            clickAdd(){
                this.form = {}
                this.dialogFormVisible = true;
            },
            handleChange(value){
                this.form.parent_id = value[value.length-1];
            },
            confirmAdd(){
                this.form.site_id = Cookies.get('siteId')
                if (!this.form.cate_name){
                    this.$alert('分类名称不能为空');
                    return false;
                }
                this.$http.post('/v1/category/save',this.form).then(({data})=>{
                    if (data.errcode == 0) {
                        this.dialogFormVisible = false;
                        this.$http.get(this.apiUrl+'/v1/category/list',{params:{siteId:Cookies.get('siteId')}}).then(({data})=>{
                            this.tableData = data.result;
                        })
                    }else {
                        this.$alert(data.msg);
                    }
                })
            },
            handleAvatarSuccess(res, file) {
                this.imageUrl = URL.createObjectURL(file.raw);
                this.form.logo = res.imgUrl;
            },
            beforeAvatarUpload(file) {
                const isJPG = (file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif');
                const isLt2M = file.size / 1024 / 1024 < 2;
                if (!isJPG) {
                    this.$message.error('上传图片只能是图片格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!');
                }
                return isJPG && isLt2M;
            },
            handleEdit(index, row) {
                this.$http.get('/v1/category/view',{params:{siteId:Cookies.get('siteId'),cate_id:row.value}}).then(({data})=>{
                    this.form = data.result;
                    this.imageUrl = data.result.logo;
                    this.selectedOptions.push(data.result.parent_id)
                })
                this.dialogFormVisible = true;
            },
            handleDelete(index, row) {
                this.$http.delete('/v1/category/delete',{params:{id:row.value}}).then(({data})=>{
                    if (data.errcode == 0) {
                        this.$message.success('删除成功');
                        this.$http.get(this.apiUrl+'/v1/category/list',{params:{siteId:Cookies.get('siteId')}}).then(({data})=>{
                            this.tableData = data;
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .avatar-uploader >>> .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader >>>  .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>
